// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2895": "fa85db70","7926": "a886ec83","9052": "b09ab37f",}[chunkId] + ".css"
}